<template>
  <div class="container pb-16">
    <navigation-drawer :titles="title"/>
    <div class="row align-items-center">
      <div class="col-md-3">
        <div class="mr-1 mb-2 font16px"> عنوان</div>
        <v-text-field
            class="rounded-lg"
            v-model="categoryTitle"
            solo
            flat
            dense
            hide-details
        ></v-text-field>
      </div>
      <div class="col-md-7">
        <div class="mb-2 mr-1">توضیحات</div>
        <editor-content :editor="description" class="text-editor"/>
      </div>
      <div class="col-auto">
        <v-checkbox hide-details class="white-main-bg rounded-lg px-3" v-model="isActive" color="primary">
          <template slot="label">
            <span class="mt-2">فعال</span>
          </template>
        </v-checkbox>
      </div>
      <div class="col-12 mt-5 text-center">
        <v-btn v-if="isNew" color="primary" class="rounded-lg" large dark
               @click="defineCategory">
          <span class="font16px">انجام</span>
        </v-btn>
        <v-btn v-else color="primary" class="rounded-lg" large dark
               @click="editCategory">
          <span class="font16px">ویرایش</span>
        </v-btn>
      </div>
    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        z-index="10000"
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NavigationDrawer from "@/Admin/components/navigationDrawer";
import {Editor, EditorContent} from 'tiptap';

export default {
  name: "ticketsCategory",
  components: {NavigationDrawer, EditorContent},
  metaInfo() {
    return {
      title: ' ادمین-' + this.newsTitle
    }
  },
  data: () => ({
    title: null,
    newsTitle: null,
    categoryTitle: null,
    description: null,
    dialogResult: null,
    isActive: false,
    isNew: true,
    showLoaderDialog: false,
    showResultDialog: false,
  }),
  mounted() {
    if (this.$route.query.isNew === 'true') {
      this.title = 'تعریف دسته بندی تیکت ها'
      this.newsTitle = 'تعریف دسته بندی تیکت ها'
      this.isNew = true
      this.description = new Editor({
        content: '',
      })
    } else {
      this.isNew = false
      this.title = 'ویرایش دسته بندی تیکت ها'
      this.newsTitle = 'ویرایش دسته بندی تیکت ها'
      this.getData()
    }
  },
  methods: {
    defineCategory() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("Name", this.categoryTitle);
      urlencoded.append("Description", this.description.getHTML());
      urlencoded.append("IsActive", this.isActive);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/DefineTicketCategory", requestOptions)
          .then(response => response.text())
          .then(result => {
            console.log(result)
            this.showLoaderDialog = false
            this.dialogResult = result

            this.$router.push({path: 'listCategoryTickets'})
          })
          .catch(error => console.log('error', error));
    },
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/EditTicketCategory?ticketCategoryId=" + this.$route.query.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.categoryTitle = json.Name
            this.description = new Editor({
              content: json.Description,
            })
            this.isActive = json.IsActive
          })
          .catch(error => console.log('error', error));
    },
    editCategory() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("Name", this.categoryTitle);
      urlencoded.append("Description", this.description.getHTML());
      urlencoded.append("IsActive", this.isActive);
      urlencoded.append("TicketCategoryId", this.$route.query.id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/EditTicketCategory", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.dialogResult = result
            this.$router.push({path:'listCategoryTickets'})
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>